<template>
    <div>
        <template v-if="show_loading">
            <v-row
                align="stretch"
                class="mt-0 mb-5"
            >
                <v-col
                    v-for="index in skeleton_count"
                    :key="`skeleton-${index}`"
                    v-bind="skeleton_col_props"
                >
                    <v-skeleton-loader
                        v-bind="skeleton_loader_props"
                        class="elevation-1"
                    />
                </v-col>
            </v-row>
        </template>

        <template v-else>
            <slot />
        </template>
    </div>
</template>

<script>
export default {
    props: {
        show_loading: {
            type: Boolean,
            default: false,
        },

        skeleton_count: {
            type: Number,
            default: 6,
        },

        skeleton_type: {
            type: String,
            default: 'image, card-heading, list-item, actions',
        },

        skeleton_height: {
            type: [String, Number],
            default: '380',
        },

        skeleton_col_props: {
            type: Object,
            default: () => ({
                cols: '12',
                sm: '6',
                md: '4',
            }),
        },
    },

    computed: {
        skeleton_loader_props() {
            return {
                type: this.skeleton_type,
                height: this.skeleton_height,
            };
        },
    },
};
</script>
